$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Data = require '../data'

module.exports =
class Meta extends Singleton

  constructor: ->
    super

    @$title       = $ 'title'
    @$description = $ 'meta[name="description"]'
    @$keywords    = $ 'meta[name="keywords"]'

  set: (target) ->
    @$title.text Data.title[target]
    @$description.attr 'content', Data.description[target]
    @$keywords.attr 'content', Data.keywords[target]



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/meta.coffee